<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-2" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-2">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #20a8d8 0%, #1783ae 100%);">
            <i class="fa fa-tag text-white"></i>
          </div>
          <div class="header-text-container">
            <h5 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Pedido de Etiqueta Avulsa</h5>
            <p class="text-muted mb-0 small">Gestão de pedidos de etiquetas avulsas</p>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-2">
          <!-- Search Pill -->
          <div class="d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
            <b-button-group class="mr-2">
              <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros Avançados">
                <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar Filtros">
                <i class="fa fa-ban"></i>
              </b-button>
            </b-button-group>

            <div class="d-flex align-items-center px-2 border-left mr-2">
              <cec-input-data ref="dt1" v-model="dt1" class="mx-1" style="width: 140px" placeholderText="Início" @keydown.enter.native="pesquisar()" />
              <span class="text-muted mx-1">àté</span>
              <cec-input-data v-model="dt2" class="mx-1" style="width: 140px" placeholderText="Fim" @keydown.enter.native="pesquisar()" />
            </div>
            
            <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white" @click="pesquisar()">
              <i class="fa fa-search mr-1"></i> FILTRAR
            </b-button>
          </div>

          <!-- Action Buttons -->
          <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm" @click.stop.prevent="abrirModal(null)">
            <i class="fa fa-plus-circle mr-2"></i>
            <span>Adicionar</span>
          </b-button>
        </div>
      </div>

      <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtroAvancado">
        <div class="px-3 pb-2">
          <div class="card card-filter-premium compact-filter p-3 border-0 shadow-sm">
            <b-row>
              <b-col sm="2">
                <label class="small font-weight-bold text-muted mb-1">ID</label>
                <b-form-input type="text" placeholder="ID" v-model="filtroId" @keydown.enter="pesquisar()"></b-form-input>
              </b-col>
              <b-col sm="2">
                <label class="small font-weight-bold text-muted mb-1">Período por</label>
                <b-form-select v-model="tipoData" @change="pesquisar()">
                  <b-form-select-option value="C">Data Cadastro</b-form-select-option>
                  <b-form-select-option value="I">Início Produção</b-form-select-option>
                  <b-form-select-option value="F">Término Produção</b-form-select-option>
                </b-form-select>
              </b-col>
              <b-col sm="3">
                <label class="small font-weight-bold text-muted mb-1">Situação</label>
                <b-form-select v-model="filtroSituacao" @change="pesquisar()">
                  <b-form-select-option :value="null">Todas</b-form-select-option>
                  <b-form-select-option value="0">Cancelado</b-form-select-option>
                  <b-form-select-option value="1">Em Cadastro</b-form-select-option>
                  <b-form-select-option value="2">Liberado p/ Coleta</b-form-select-option>
                  <b-form-select-option value="3">Em Coleta</b-form-select-option>
                  <b-form-select-option value="4">Coletado</b-form-select-option>
                </b-form-select>
              </b-col>
              <b-col sm="3">
                <label class="small font-weight-bold text-muted mb-1">Tipo de Produção</label>
                <b-form-select v-model="filtroTipo" @change="pesquisar()">
                  <b-form-select-option :value="null">Todos</b-form-select-option>
                  <b-form-select-option value="0">Troca de Tampa</b-form-select-option>
                  <b-form-select-option value="1">Outros</b-form-select-option>
                </b-form-select>
              </b-col>
              <b-col sm="2">
                <label class="small font-weight-bold text-muted mb-1">Solicitante</label>
                <funcionario-dropdown v-model="filtroResponsavelId" placeholder="Todos" />
              </b-col>
            </b-row>
          </div>
        </div>
      </b-collapse>

      <!-- Tabela -->
      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table 
              class="mb-0 table-finance"
              id="table-pedido-etiqueta-avulsa"
              ref="tbl"
              :items="itensFiltrados"
              :fields="fields"
              :per-page="perPage"
              :current-page="currentPage"
              :sticky-header="stickyHeight"
              :tbody-tr-class="rowClassSelecionado"
              :head-variant="isDark ? 'dark' : 'light'"
              :dark="isDark"
              hover 
              small 
              bordered 
              @row-clicked="clicarLinha"
              @row-dblclicked="abrirModal"
              show-empty
              empty-text="Nenhum registro encontrado"
              responsive 
            >
              <!-- Filtros nos Headers -->
              <template #head(ID)>
                <SetFilter
                  label="ID"
                  v-model="filtros.ID"
                  :options="opcoes.ID"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(LOTE)>
                <SetFilter
                  label="Lote"
                  v-model="filtros.LOTE"
                  :options="opcoes.LOTE"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(OP_TIPO)>
                <SetFilter
                  label="Tipo"
                  v-model="filtros.OP_TIPO"
                  :options="opcoes.OP_TIPO"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(SITUACAO)>
                <SetFilter
                  label="Situação"
                  v-model="filtros.SITUACAO"
                  :options="opcoes.SITUACAO"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(RESPONSAVEL_NOME)>
                <SetFilter
                  label="Solicitante"
                  v-model="filtros.RESPONSAVEL_NOME"
                  :options="opcoes.RESPONSAVEL_NOME"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>

              <!-- Ícone de ação: seta detalhes -->
              <template #cell(DETALHE)="row">
                <i 
                  :class="row.detailsShowing ? 'fa fa-angle-up' : 'fa fa-angle-down'"
                  @click.stop="toggleDetalhes(row)"
                  style="cursor: pointer"
                  title="Ver Etiquetas Geradas"
                  v-b-tooltip.hover
                ></i>
              </template>

              <!-- Detalhes: lista de etiquetas -->
              <template #row-details="row">
                <div v-if="row.item.loading" class="text-center py-3">
                  <b-spinner small></b-spinner> Carregando etiquetas...
                </div>
                <div v-else-if="!row.item.etiquetas || row.item.etiquetas.length === 0" class="text-center py-3 text-muted">
                  Nenhuma etiqueta gerada para este pedido
                </div>
                <div v-else class="px-3 py-2">
                  <h6 class="mb-2">Etiquetas Geradas ({{ row.item.etiquetas.length }})</h6>
                  <b-table 
                    head-variant="dark"
                    hover
                    small
                    bordered
                    :table-variant="isDark ? 'primary' : 'light'"
                    :items="row.item.etiquetas" 
                    :fields="tabelaEtiquetas.fields"
                  >
                    <template #cell(DATA_CADASTRO)="data">
                      {{ formatarDataHora(data.item.DATA_CADASTRO) }}
                    </template>
                  </b-table>
                </div>
              </template>

              <template #cell(SITUACAO)="data">
                <b-badge pill class="px-3 py-1 shadow-xs" :variant="variantSituacao(data.item.SITUACAO)">
                  {{ traduzirSituacao(data.item.SITUACAO) }}
                </b-badge>
              </template>

              <template #cell(OP_TIPO)="data">
                {{ data.item.OP_TIPO === '0' ? 'TROCA DE TAMPA' : 'OUTROS' }}
              </template>

              <template #cell(DATA)="data">
                {{ formatarData(data.item.DATA) }}
              </template>

              <template #cell(DATA_CADASTRO)="data">
                {{ formatarDataHora(data.item.DATA_CADASTRO) }}
              </template>

              <template #cell(actions)="item">
                <div class="d-flex align-items-center gap-1 justify-content-end">
                  <b-button 
                    v-if="item.item.SITUACAO === '1'" 
                    type="button" 
                    @click.stop="liberar(item.item)" 
                    variant="soft-success" 
                    pill 
                    class="btn-icon-only shadow-sm" 
                    title="Liberar para Terminal" 
                    v-b-tooltip.hover
                  >
                    <i class="fa fa-check"></i>
                  </b-button>
                  <b-button 
                    v-if="item.item.SITUACAO === '3'" 
                    type="button" 
                    @click.stop="fecharPedido(item.item)" 
                    variant="soft-success" 
                    pill 
                    class="btn-icon-only shadow-sm" 
                    title="Fechar Pedido (Coletado)" 
                    v-b-tooltip.hover
                  >
                    <i class="fa fa-flag-checkered"></i>
                  </b-button>
                  <b-button type="button" @click.stop="abrirModal(item.item)" variant="soft-info" pill class="btn-icon-only shadow-sm" title="Editar" v-b-tooltip.hover>
                    <i class="fa fa-pencil"></i>
                  </b-button>
                  <b-button 
                    v-if="item.item.SITUACAO === '1' || item.item.SITUACAO === '2'" 
                    type="button" 
                    @click.stop="deletar(item.item)" 
                    variant="soft-danger" 
                    pill 
                    class="btn-icon-only shadow-sm" 
                    title="Excluir" 
                    v-b-tooltip.hover
                  >
                    <i class="fa fa-times"></i>
                  </b-button>
                </div>
              </template>

              <template #custom-foot>
                <b-tr>
                  <b-td colspan="10" class="text-right font-weight-bold bg-light">
                    Total de registros: {{ itensFiltrados.length }} / {{ lista.length }}
                  </b-td>
                </b-tr>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>
    
    <!-- Modal de Cadastro/Edição -->
    <PedidoEtiquetaAvulsaModal 
      ref="modalPedido"
      @salvou="pesquisar"
    />
  </div>
</template>

<script>
import PedidoEtiquetaAvulsaModal from './PedidoEtiquetaAvulsaModal.vue'
import FuncionarioDropdown from '@/views/componentes/dropdown/FuncionarioDropdown.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import Tools from '@/tools/tools.js'
import moment from 'moment'

export default {
  components: {
    PedidoEtiquetaAvulsaModal,
    FuncionarioDropdown,
    CecInputData,
    SetFilter
  },
  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    preferVh: 69,
    useExternalPaging: true,
    filters: [
      { key: 'ID', type: 'string', label: 'ID' },
      { key: 'LOTE', type: 'string', label: 'Lote' },
      { key: 'OP_TIPO', type: 'string', label: 'Tipo', 
        labelMap: { '0': 'TROCA DE TAMPA', '1': 'OUTROS' }
      },
      { key: 'SITUACAO', type: 'string', label: 'Situação',
        labelMap: { 
          '0': 'CANCELADO',
          '1': 'EM CADASTRO', 
          '2': 'LIBERADO P/ COLETA',
          '3': 'EM COLETA',
          '4': 'COLETADO'
        }
      },
      { key: 'RESPONSAVEL_NOME', type: 'string', label: 'Solicitante' }
    ]
  })],

  data () {
    return {
      isBusy: false,
      filtroAvancado: false,
      filtroId: null,
      filtroSituacao: null,
      filtroTipo: null,
      filtroResponsavelId: null,
      dt1: moment().format('YYYY-MM-DD'),
      dt2: moment().format('YYYY-MM-DD'),
      tipoData: 'C',
      lista: [],
      registroSelecionadoId: null,
      currentPage: 1,
      stickyHeight: '75vh',
      fields: [
        { key: 'DETALHE', label: '', sortable: false, thStyle: 'width: 40px' },
        { key: 'ID', label: 'ID', sortable: true, thStyle: 'width: 80px' },
        { key: 'DATA', label: 'Previsão Prod.', sortable: true, thStyle: 'width: 120px' },
        { key: 'LOTE', label: 'Lote', sortable: true, thStyle: 'width: 100px' },
        { key: 'LOTE_DIGITO', label: 'Dígito', sortable: true, thStyle: 'width: 80px' },
        { key: 'OP_TIPO', label: 'Tipo', sortable: true, thStyle: 'width: 150px' },
        { key: 'SITUACAO', label: 'Situação', sortable: true, thStyle: 'width: 130px' },
        { key: 'RESPONSAVEL_NOME', label: 'Solicitante', sortable: true },
        { key: 'OBSERVACAO', label: 'Observações', sortable: false },
        { key: 'DATA_CADASTRO', label: 'Data Cadastro', sortable: true, thStyle: 'width: 150px' },
        { key: 'actions', label: 'Ações', thStyle: 'width: 100px' }
      ],
      tabelaEtiquetas: {
        fields: [
          { key: 'ID', label: 'ID', sortable: false, thStyle: 'width: 80px' },
          { key: 'CODIGO', label: 'Código', sortable: false },
          { key: 'CODIGO_FORMATADO', label: 'Código Formatado', sortable: false },
          { key: 'DATA_CADASTRO', label: 'Data Cadastro', sortable: false, thStyle: 'width: 150px' },
          { key: 'USUARIO_CADASTRO', label: 'Usuário', sortable: false, thStyle: 'width: 120px' }
        ]
      }
    }
  },
  
  computed: {
    isDark() {
      return this.$store.getters['tema/IS_DARK']
    }
  },

  methods: {
    traduzirSituacao(situacao) {
      const map = {
        '0': 'CANCELADO',
        '1': 'EM CADASTRO',
        '2': 'LIBERADO P/ COLETA',
        '3': 'EM COLETA',
        '4': 'COLETADO'
      }
      return map[situacao] || 'DESCONHECIDO'
    },
    variantSituacao(situacao) {
      const map = {
        '0': 'danger',
        '1': 'warning',
        '2': 'info',
        '3': 'primary',
        '4': 'success'
      }
      return map[situacao] || 'secondary'
    },
    formatarData(data) {
      if (!data) return ''
      return Tools.formatarDataBR(data)
    },
    formatarDataHora(data) {
      if (!data) return ''
      return Tools.formatarDataHoraBR(data)
    },
    clicarLinha(item) {
      this.registroSelecionadoId = item.ID
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      return item.ID === this.registroSelecionadoId ? 'cec-row-selected' : ''
    },
    limparFiltro() {
      this.filtroId = null
      this.filtroSituacao = null
      this.filtroTipo = null
      this.filtroResponsavelId = null
      this.dt1 = moment().format('YYYY-MM-DD')
      this.dt2 = moment().format('YYYY-MM-DD')
      this.tipoData = 'C'
      this.lista = []
    },
    abrirModal(item) {
      this.$refs.modalPedido.abrir(item)
    },
    async pesquisar() {
      if (!this.dt1 || !this.dt2) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Informe o período (data inicial e final)')
        return
      }

      this.isBusy = true
      this.$store.commit('controle/setAguardando', true)
      
      try {
        const params = {
          dt1: this.dt1,
          dt2: this.dt2,
          tipoData: this.tipoData
        }
        if (this.filtroId) params.id = this.filtroId
        if (this.filtroSituacao) params.situacao = this.filtroSituacao
        if (this.filtroTipo) params.opTipo = this.filtroTipo
        if (this.filtroResponsavelId) params.responsavelId = this.filtroResponsavelId

        const { data } = await this.$http.get('/api/protected/pedido-etiqueta-avulsa/pesquisar', { params })
        this.lista = data || []
        
      } catch(err) {
        this.lista = []
        let msg 
        if (err.response && err.response.status) {
          msg = err.response.data
          Tools.exibirMensagem(this.$store, 'Falha', 'warning', msg)
        } else {
          Tools.exibirMensagem(this.$store, 'Falha', 'danger', `Falha ao pesquisar: ${err.message}`)
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
        this.isBusy = false
        this.$nextTick(() => {
          this.$refs.dt1?.focus()
        })
      }
    },
    async liberar(item) {
      const msg = await this.$bvModal.msgBoxConfirm(
        `Deseja liberar o pedido #${item.ID} para coleta no terminal?`,
        {
          title: 'Confirmar Liberação',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: 'SIM, LIBERAR',
          cancelTitle: 'NÃO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )
      
      if (!msg) return

      try {
        this.$store.commit('controle/setAguardando', true)
        await this.$http.post('/api/protected/pedido-etiqueta-avulsa/liberar', { 
          id: item.ID,
          login: window.localStorage.getItem('login')
        })
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Pedido liberado para coleta!')
        this.pesquisar()
      } catch(err) {
        let msg = err.response?.data || err.message
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', msg)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async fecharPedido(item) {
      const msg = await this.$bvModal.msgBoxConfirm(
        `Deseja fechar o pedido #${item.ID} como COLETADO?`,
        {
          title: 'Confirmar Fechamento',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: 'SIM, FECHAR',
          cancelTitle: 'NÃO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )
      
      if (!msg) return

      try {
        this.$store.commit('controle/setAguardando', true)
        await this.$http.post('/api/protected/pedido-etiqueta-avulsa/fechar', { 
          id: item.ID,
          login: window.localStorage.getItem('login')
        })
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Pedido fechado com sucesso!')
        this.pesquisar()
      } catch(err) {
        let msg = err.response?.data || err.message
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', msg)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async deletar(item) {
      const msg = await this.$bvModal.msgBoxConfirm(`Deseja excluir o pedido #${item.ID}?`, {
        title: 'Confirmar Exclusão',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      
      if (!msg) return

      try {
        this.$store.commit('controle/setAguardando', true)
        await this.$http.post('/api/protected/pedido-etiqueta-avulsa/delete', { 
          id: item.ID,
          login: window.localStorage.getItem('login')
        })
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Pedido excluído com sucesso!')
        this.pesquisar()
      } catch(err) {
        let msg = err.response?.data || err.message
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', msg)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    handleKeydown(event) {
      if (event.key === "Insert") {
        this.abrirModal(null)
      }
    }
  },

  mounted() {
    setTimeout(() => {
      document.addEventListener("keydown", this.handleKeydown)
    }, 200)
    
    this.$nextTick(() => {
      this.$refs.edLote?.focus()
    })
  },

  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown)
  }
}
</script>

<style scoped>
/* Table Sticky Header */
.b-table-sticky-header > .table.b-table > thead > tr > th,
.b-table-sticky-header .table-responsive > .table.b-table > thead > tr > th {
  position: sticky !important;
  top: 0;
  z-index: 2;
  background-clip: padding-box;
}

.b-table-sticky-header .table-responsive {
  max-height: inherit;
  overflow-y: auto;
}

/* Linha Selecionada */
.table.b-table tbody tr.cec-row-selected,
.table.b-table tbody tr.cec-row-selected > td {
  background-color: #c2cfd6 !important;
  color: #000000 !important;
}

.table.b-table tbody tr.cec-row-selected a {
  color: #000000 !important;
}

/* Table Enhancements */
.table-finance thead th {
  background-color: #f8f9fa !important;
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 700;
  color: #495057;
  letter-spacing: 0.5px;
  border-top: none !important;
  border-bottom: 2px solid #dee2e6 !important;
  padding: 4px 6px !important;
}

.table-finance tbody td {
  vertical-align: middle !important;
  padding: 2px 6px !important;
  color: #4a5568;
  font-size: 0.8rem;
}

.table-finance tr:hover {
  background-color: rgba(66, 153, 225, 0.05) !important;
}

.header-icon-wrapper {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  font-size: 1.2rem;
}

.btn-icon-only {
  width: 32px;
  height: 32px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn-soft-danger {
  background-color: rgba(248, 108, 107, 0.1);
  color: #f86c6b;
  border: none;
}
.btn-soft-danger:hover {
  background-color: #f86c6b;
  color: white;
}

.btn-soft-info {
  background-color: rgba(99, 194, 222, 0.1);
  color: #63c2de;
  border: none;
}
.btn-soft-info:hover {
  background-color: #63c2de;
  color: white;
}

.btn-soft-success {
  background-color: rgba(76, 175, 80, 0.1);
  color: #4caf50;
  border: none;
}
.btn-soft-success:hover {
  background-color: #4caf50;
  color: white;
}

.btn-soft-warning {
  background-color: rgba(255, 193, 7, 0.1);
  color: #ffc107;
  border: none;
}
.btn-soft-warning:hover {
  background-color: #ffc107;
  color: white;
}

.shadow-xs {
  box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/estoque/pedido-etiqueta-avulsa/PedidoEtiquetaAvulsaListagem.vue